import React, {FC, useEffect, useMemo, useRef, useState} from 'react'
import {
  fetchData,
  formatNumber,
  getEncryptedRoute,
  toasterrormsg,
  useMenuIdPermissions,
} from '../../../../reusable'
import {KTIcon} from '../../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import {Link} from 'react-router-dom'
import Select from 'react-select'
import {Tr} from '../../../../_metronic/i18n/Tr'

const ViewAdminVendorPayment: FC = () => {
  let t = Tr()
  const {menuIdEdit, menuId} = useMenuIdPermissions()

  const [paymentDetailList, setPaymentDetailList] = useState([])
  const [orgPaymentDetailList, setOrgPaymentDetailList] = useState([])

  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [totalServiceAmount, setTotalServiceAmount] = useState('')
  const [totalAmount, setTotalAmount] = useState('')
  const [totalBooking, setTotalBooking] = useState('')
  const [paidPercentage, setPaidPercentage] = useState('')

  const currentMonth = new Date().getMonth() + 1

  const [monthList] = useState([
    {value: '1', label: 'January'},
    {value: '2', label: 'February'},
    {value: '3', label: 'March'},
    {value: '4', label: 'April'},
    {value: '5', label: 'May'},
    {value: '6', label: 'June'},
    {value: '7', label: 'July'},
    {value: '8', label: 'August'},
    {value: '9', label: 'September'},
    {value: '10', label: 'October'},
    {value: '11', label: 'November'},
    {value: '12', label: 'December'},
  ]) as any

  const currentYear = new Date().getFullYear()
  const yearList = Array.from({length: currentYear - 2020 + 1}, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  const [selectedMonth, setSelectedMonth] = useState(currentMonth) as any
  const [selectedYear, setSelectedYear] = useState(currentYear) as any

  const clearFields = () => {
    setSelectedYear(currentYear)
    setSelectedMonth(currentMonth)
    paymentDetailListApiCall('1', currentYear, currentMonth)
  }

  const getMonthStartAndEndDates = (year: number, month: number) => {
    if (!year || !month) {
      return {
        startDate: '',
        endDate: '',
      }
    }
    const startDate = new Date(year, month - 1, 1)
    const endDate = new Date(year, month, 0)

    // Format dates in 'YYYY-MM-DD' to avoid timezone-related issues
    const formattedStartDate = `${String(startDate.getDate()).padStart(2, '0')}-${String(
      startDate.getMonth() + 1
    ).padStart(2, '0')}-${startDate.getFullYear()}`
    const formattedEndDate = `${String(endDate.getDate()).padStart(2, '0')}-${String(
      endDate.getMonth() + 1
    ).padStart(2, '0')}-${endDate.getFullYear()}`

    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }
  }

  const paymentDetailListApiCall = async (
    isclear: any,
    year = selectedYear,
    month = selectedMonth
  ) => {
    const {startDate, endDate} = getMonthStartAndEndDates(year, month)

    var param: any = ''

    if (isclear == '1') {
      param = {
        fromDate: startDate,
        toDate: endDate,
      }
    } else {
      param = {
        fromDate: startDate,
        toDate: endDate,
      }
    }
    var res = await fetchData('admin/adminrevenue', param)

    if (res.status == '200') {
      var data = res.data
      const totalServiceFeeAmount = data.reduce((acc: number, item: any) => {
        return acc + (item.serviceFeeAmount ? parseFloat(item.serviceFeeAmount) : 0)
      }, 0)
      setTotalServiceAmount(totalServiceFeeAmount)

      const totalAmount = data.reduce((acc: number, item: any) => {
        return acc + (item.totalAmount ? parseFloat(item.totalAmount) : 0)
      }, 0)
      setTotalAmount(totalAmount)

      const totalBooking = data.reduce((acc: number, item: any) => {
        return acc + (item.numberOfBookings ? parseFloat(item.numberOfBookings) : 0)
      }, 0)
      setTotalBooking(totalBooking)

      const totalLength = data.length // Total number of records
      const paidCount = data.filter((item: any) => item.feeStatus === 'paid').length // Number of paid records      
      // Calculate the percentage of paid fees
      const paidPercentage = (paidCount / totalLength) * 100

      setPaidPercentage(paidPercentage.toFixed(2))
      setPaymentDetailList(data)
      setOrgPaymentDetailList(data)
    } else {
      toasterrormsg(res.message)
    }
  }

  // search Coupon
  const paymentDetailSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setPaymentDetailList(orgPaymentDetailList)
    } else {
      var tmp: any = orgPaymentDetailList.filter((item: any) => {
        return (
          (item.categoryName != null &&
            item.categoryName != '' &&
            String(item.categoryName).includes(text)) ||
          (item.numberOfBookings != null &&
            item.numberOfBookings != '' &&
            String(item.numberOfBookings).includes(text)) ||
          (item.serviceFeeAmount != null &&
            item.serviceFeeAmount != '' &&
            String(item.serviceFeeAmount).toLowerCase().includes(text.toLowerCase())) ||
          (item.serviceFee != null &&
            item.serviceFee != '' &&
            String(item.serviceFee).toLowerCase().includes(text.toLowerCase())) ||
          (item.percentagePaid != null &&
            item.percentagePaid != '' &&
            String(item.percentagePaid).toLowerCase().includes(text.toLowerCase()))
        )
      })

      setPaymentDetailList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Payment Details')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }

  // Define your DataTable columns
  var column = useMemo(
    () => [
      {
        name: t('Service Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5 text-primary under text-decoration-underline cursor-pointer'>
              {row.categoryName != 'Total' ? (
                <Link
                  to={getEncryptedRoute('../viewadminvendorpaymentdetails/', {menuId:menuId})}
                  state={{
                    previousSelectedYear: selectedYear,
                    previousSelectedMonth: selectedMonth,
                    categoryId:
                      row.categoryName == 'Accomodation'
                        ? '1'
                        : row.categoryName == 'Space Rental'
                        ? '4'
                        : row.categoryName == 'Tour Packages'
                        ? '5'
                        : row.categoryName == 'Car Rental'
                        ? '7'
                        : '',
                  }}
                >
                  {' '}
                  {row.categoryName != '' ? row.categoryName : '-'}
                </Link>
              ) : (
                'Total'
              )}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.categoryName),
        width: '200px',
      },

      {
        name: t('Period'),
        cell: (row: any) => (
          <div className='my-3 '>
            <div className='fw-bold fs-5 '>
              {row.fromDate != 'custom'
                ? row.fromDate != ''
                  ? moment(row.fromDate).format('DD.MM.YYYY')
                  : '-'
                : ''}{' '}
              {'- '}
              {row.toDate != 'custom'
                ? row.toDate != ''
                  ? moment(row.toDate).format('DD.MM.YYYY')
                  : '-'
                : ''}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.fullName),
        filter: true,
        width: '222px',
      },

      {
        name: t('Number of Bookings'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.numberOfBookings != '' ? row.numberOfBookings : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.numberOfBookings),
        filter: true,
        width: '222px',
      },

      {
        name: t('Total Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount != '' && row.totalAmount != '0'
                ? formatNumber(parseFloat(row.totalAmount))
                : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.totalAmount),
        filter: true,
        width: '200px',
      },
      {
        name: t('Insayr Service Fee'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.serviceFee != '' ? row.serviceFee + '%' : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.serviceFee),
        filter: true,
        width: '200px',
      },
      {
        name: t('Insayr Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.serviceFeeAmount != ''
                ? formatNumber(parseFloat(row.serviceFeeAmount))
                : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.serviceFeeAmount),
        filter: true,
        width: '200px',
      },
      {
        name: t('Percentage Paid'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {/* {row.percentagePaid != '' ? row.percentagePaid + '%' : '-'} */}
              {row.percentagePaid == '' ? '-' : '12%'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.percentagePaid),
        filter: true,
        width: '200px',
      },
      {
        name: t('Fee Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              {isNaN(row.feeStatus) ? (
                row.feeStatus == 'pending' ? (
                  <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    {t('Pending')}
                  </span>
                ) : row.feeStatus == 'approved' ? (
                  <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    {t('Approved')}
                  </span>
                ) : row.feeStatus == 'rejected' ? (
                  <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    {t('Rejected')}
                  </span>
                ) : row.feeStatus == 'canceled' ? (
                  <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    {t('Cancelled')}
                  </span>
                ) : (
                  <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    {t('Completed')}
                  </span>
                )
              ) : (
                row.feeStatus + '% Paid'
              )}
            </label>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.feeStatus),
        filter: true,
      },
    ],
    [selectedMonth, selectedYear , t]
  )

  useEffect(() => {
    paymentDetailListApiCall('0')
    document.title = 'Insayr | View Revenue Breakdown'
  }, [])

  const customRow = {
    categoryName: 'Total', // Example custom data
    fromDate: 'custom',
    toDate: 'custom',
    numberOfBookings: totalBooking,
    totalAmount: totalAmount,
    serviceFee: '',
    serviceFeeAmount: totalServiceAmount,
    percentagePaid: '',
    feeStatus: paidPercentage, // Example status
  }

  // Step 2: Add the custom row to your data array
  const updatedPaymentDetailList = [...paymentDetailList, customRow]
  return (
    <>
      <div className='container'>
        <div className='justify-content-center d-flex flex-wrap gap-5 mb-6'>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              {t('Select Month')}
            </label>
            <Select
              name='selectVendorMonth'
              id='selectVendorMonth'
              placeholder={t('Select Month')}
              isSearchable={true}
              options={monthList}
              value={monthList.find((option: any) => option.value == selectedMonth) || null}
              onChange={(e: any) => {
                setSelectedMonth(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              {t('Select Year')}
            </label>
            <Select
              name='selectVendorYear'
              id='selectVendorYear'
              placeholder={t('Select Year')}
              isSearchable={true}
              options={yearList}
              value={yearList.find((option: any) => option.value == selectedYear) || null}
              onChange={(e: any) => {
                setSelectedYear(e.value)
              }}
            />
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-center mb-5'>
        <div className='col-md-2 mb-3 d-flex align-items-end'>
          <button className='btn btn-primary mx-1' onClick={() => paymentDetailListApiCall('0')}>
            {t('Apply')}
          </button>
          <button className='btn btn-danger mx-1' onClick={() => clearFields()}>
            {t('Clear')}
          </button>
        </div>
      </div>

      <ToastContainer />

      <>
        <DataTable
          columns={column}
          data={updatedPaymentDetailList}
          pagination
          paginationServer={false}
          subHeader={true}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={paymentDetailSearch} />
          }
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
          }}
        />
      </>
    </>
  )
}

export {ViewAdminVendorPayment}
